import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/uiDir/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/uiDir/avatar";
import { Button } from "@/components/uiDir/button";
import { Briefcase, ExternalLink } from "lucide-react";

interface Opportunity {
  project_id: string;
  opportunity: string;
  author_username: string;
  author_avatar: string;
  author_name: string;
  project_title: string;
}

interface OpportunitiesProps {
  opportunities: Opportunity[];
  getInitials: (name: string) => string;
}

export const Opportunities = ({ opportunities, getInitials }: OpportunitiesProps) => {
  return (
    <Card className="border-0 shadow-lg bg-gradient-to-br from-green-50 to-emerald-50">
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-semibold flex items-center gap-2">
          <Briefcase className="h-4 w-4 text-green-600" />
          Opportunities
        </CardTitle>
      </CardHeader>
      {opportunities && opportunities.length > 0 ? (
        <CardContent className="space-y-3">
          {opportunities.map((op) => (
            <Link key={op.project_id + op.opportunity} to={`/profile/${op.author_username}#${op.project_id}`}>
              <div className="p-3 bg-white rounded-lg hover:bg-gray-50 transition-colors">
                <div className="flex items-start gap-3">
                  <Avatar className="h-8 w-8 mt-0.5 flex-shrink-0"><AvatarImage src={op.author_avatar} /><AvatarFallback>{getInitials(op.author_name)}</AvatarFallback></Avatar>
                  <div><p className="font-medium text-sm leading-tight">{op.opportunity}</p><p className="text-xs text-gray-500 line-clamp-1">for "{op.project_title}"</p></div>
                </div>
              </div>
            </Link>
          ))}
          <Link to="/opportunities">
            <Button variant="outline" size="sm" className="w-full">View All<ExternalLink className="h-3 w-3 ml-2" /></Button>
          </Link>
        </CardContent>
      ) : (<CardContent className="text-center text-sm text-gray-500 py-8">No open opportunities right now.</CardContent>)}
    </Card>
  );
};